// components/ui/vertical-separator.tsx
export function VerticalSeparator({
  className = "",
  isLandingPage = false,
}: {
  className?: string;
  isLandingPage?: boolean;
}) {
  return (
    <div
      className={`w-[2px] h-6 mx-2 ${
        isLandingPage
          ? "bg-white/80 shadow-[0_0_8px_rgba(255,255,255,0.2)]"
          : "bg-gray-800/60"
      } ${className}`}
      aria-hidden="true"
    />
  );
}
